import getAction from "./actions";
import getCondition from "./conditions.js";

/**
 * @typedef {Object} PersonalizationRule
 * @property {string|number} id
 * @property {string} name
 * @property {Array<import('./conditions.js').PersonalizationCondition>} conditions
 * @property {Array<import('./actions.js').PersonalizationAction>} actions
 */

/**
 * @typedef {Array<PersonalizationRule>} PersonalizationRules
 */

/**
 * @type {PersonalizationRules}
 */
const globalRules = [
  // ----- EXAMPLE RULES -----
  /*
  {
    id: "example-nav-cta-login-non-pd-users",
    name: "Example: Update Nav CTA for PD Users in EU",
    conditions: [
      getCondition("isPDUserExcludingEmployees"),
      getCondition("inEU"),
    ],
    actions: [getAction("updateNavStartForFreeCTA")],
  },
  {
    id: "example-nav-cta-login-pd-users",
    name: "Example: Update Nav CTA for PD Users outside the US and non-PD Users in the US",
    conditions: [
      (store) => {
        const isPDUser = store?.get("isPDUser");
        const cfData = store?.get("cfData");

        return (
          (isPDUser === true && cfData?.country !== "US") ||
          (isPDUser === false && cfData?.country === "US")
        );
      },
    ],
    actions: [getAction("updateNavStartForFreeCTA")],
  },
  {
    id: "example-special-offer-us-visitors",
    name: "Example: Special Offer for US visitors",
    conditions: [
      (store) => {
        const cfData = store?.get("cfData");
        return cfData?.country === "US";
      },
    ],
    actions: [
      () => {
        const offer = document.querySelector(".special-offer");
        offer?.classList.remove("hidden");
      },
    ],
  },
  */
];

export default globalRules;
